import * as React from 'react';
import { NavLink } from 'react-router-dom';
import clsx from 'clsx';
import type { NavItemProps } from './types';

/**
 * NavItem View Component
 * Renders a single navigation entry with asset icons from /assets/images/svg.
 */
export const NavItem: React.FC<NavItemProps> = ({
  to,
  label,
  icon,
  focusedIcon,
  isCollapsed,
  size,
  collapsedIconSize,
  onClick,
}) => {
  const iconSize = isCollapsed && collapsedIconSize ? collapsedIconSize : size;

  return (
    <NavLink
      to={to}
      onClick={onClick}
      className={({ isActive }) =>
        clsx(
          'group mx-auto flex items-center transition-all duration-200',
          !isCollapsed && 'h-[clamp(34px,5.5dvh,46px)] w-full rounded-10 px-3 xl:h-187 xl:w-187',
          isCollapsed && 'size-[48px] justify-center rounded-10 p-0',
          !isActive && 'bg-transparent font-normal text-brand-800 hover:bg-gray-50',
          isActive && 'font-semibold text-white'
        )
      }
      style={({ isActive }) =>
        isActive
          ? {
              border: '2px solid transparent',
              backgroundClip: 'padding-box, border-box',
              backgroundOrigin: 'padding-box, border-box',
              backgroundImage: `
                linear-gradient(to right, #1A1036, #2C1470), 
                linear-gradient(to right, #45349E, #BFB0F8)
              `,
            }
          : undefined
      }
      title={isCollapsed ? label : undefined}
    >
      {({ isActive }) => (
        <>
          <img
            src={isActive ? focusedIcon : icon}
            alt=''
            className='shrink-0 object-contain transition-opacity'
            style={{ width: `${iconSize}px`, height: `${iconSize}px` }}
          />
          {!isCollapsed && (
            <span className='ml-3 whitespace-nowrap font-sans text-18 leading-nav tracking-normal short:text-16'>
              {label}
            </span>
          )}
        </>
      )}
    </NavLink>
  );
};

export default NavItem;
